let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l40lY")).then(() => parcelRequire('fY3gY'));